<template>
<div style="margin-top:10px;">
    <v-row class="justify-center">
        <v-col cols="10" md="6">
            <v-carousel
                cycle
                height="350"
                hide-delimiter-background
                show-arrows-on-hover
            >
                <v-carousel-item
                v-for="(slide, i) in slides"
                :key="i"
                :src="slides[i].img"
                reverse-transition="fade-transition"
                stransition="fade-transition"
                >
                <p class="slide-title justify-center text-center"><b>{{ slides[i].text }}</b></p>
                </v-carousel-item>
            </v-carousel>
        </v-col>
    </v-row>
    <br>
    <Menu />
</div>
</template>

<script>
import Menu from "../components/Menu";
import data_ from '../plugins/data.json'

export default {
    name: "Home",
    components: {
        Menu,
    },
    data: () => ({
        colors: data_['colors'],
        slides: [
          {'text':'Busca palabras que rimen y conectalas', 'icon':'mdi-lightbulb-on', 'img':'https://i.ytimg.com/vi/vsKdMG7Mgug/maxresdefault.jpg'},
          {'text':'Coloca un lápiz en tu boca, sujétalo con los dientes y pronuncia las palabras','icon':'mdi-pencil', 'img':'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0v9sZxdGAeUhc15u2Sf-UPAutIcrGYMDysbySQAqK7gQhNhTo7vnUmO2ruaVpTvk59LA&usqp=CAU'},
          {'text':'Amplía tu vocabulario', 'icon':'mdi-book-open-page-variant', 'img':'https://depor.com/resizer/wngsOtfdiRgMu2gCPa5D72ReBCg=/1200x1200/smart/filters:format(jpeg):quality(75)/cloudfront-us-east-1.images.arcpublishing.com/elcomercio/JYMDQYJAPFGFNENNOFM32XTPAU.jpg'},
          {'text':'Comienza por estructurar frases cortas, a un ritmo lento-moderado.', 'icon':'mdi-lightbulb-on', 'img':'https://i2.wp.com/bizarromesa.com/wp-content/uploads/2020/10/DESTACADA-marithea-2020.png?fit=364%2C268&ssl=1'},
          {'text':'Escribe algunas letras.', 'icon':'mdi-lightbulb-on', 'img':'https://pbs.twimg.com/media/EudjtMqWYAcp15E.jpg'},
        ],
    }),
};
</script>

<style scoped>
.slide-title {
    color: white;
    font-size: 2.5em;
    background: black;
    opacity: 0.7;
    padding: 0.5em;
    height: 100%;
}
</style>
